export var LabelCssClass;
(function (LabelCssClass) {
    LabelCssClass["Base"] = "iress-label";
    LabelCssClass["Label"] = "iress-label__label";
    LabelCssClass["LabelText"] = "iress-label__text";
    LabelCssClass["HiddenLabel"] = "iress-label--hidden";
    LabelCssClass["Required"] = "iress-label__required";
    LabelCssClass["Optional"] = "iress-label__optional";
})(LabelCssClass || (LabelCssClass = {}));
//# sourceMappingURL=label.types.js.map